// This file was automatically generated from shared.commentReplyForm.html.
// Please don't edit this file by hand.

goog.provide('el8.template.shared.commentReplyForm');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm.inlineDialog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="comment-reply-container el8ResponsesInputItem"><form class="comment-reply-form el8ResponsesReplyForm"><div class="el8TextareaWrapLessMargin"><textarea name="replyBody" class="el8ResponsesInput comment-reply-body ebs-form-control" title="Reply Body"></textarea></div><div class="comment-reply-buttons"></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm.replyTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (el8Globals.APP) {
    case 'passport':
      el8.template.shared.commentReplyForm._passportReplyTrigger(opt_data, output);
      break;
    case 'access':
      el8.template.shared.commentReplyForm._accessReplyTrigger(opt_data, output);
      break;
    case 'chart':
    case 'home':
      el8.template.shared.commentReplyForm._appReplyTrigger(opt_data, output);
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm._appReplyTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.closeTime) ? '<li class="el8ResponsesItem">' + ((opt_data.canReopenThread) ? '</span><button class="el8button fr mtneg3 el8ShortButton reopen-comments-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">Reopen Conversation</button>' : '') + '<p class="el8SystemText">' + soy.$$escapeHtml(opt_data.closeUserName) + ' ended this conversation on ' + (soy.$$escapeHtml(opt_data.closeTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.closeTime)) : '') + '</p></li>' : (! el8Globals.READ_ONLY || el8Globals.PASSPORT_EMR) ? '<li class="comment-reply-container el8ResponsesInputItem"><ul class="el8ButtonContainer">' + ((! el8Globals.READ_ONLY) ? '<li class="el8ButtonItem"><button type="button" class="el8button comment-reply-trigger el8PrimaryButton ebs-btn ebs-btn-primary' + ((el8Globals.PASSPORT_EMR) ? ' el8LargeButton' : '') + '" data-doc-id="' + soy.$$escapeHtml(opt_data.id) + '">Reply</button></li>' + ((opt_data.isPtLetter) ? (! opt_data.signDate) ? '<li class="el8ButtonItem"><button type="button" class="el8button sign-and-close-pt-comments-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-doc-id="' + soy.$$escapeHtml(opt_data.id) + '">Sign off & End Conversation</button></li>' : '<li class="el8ButtonItem"><button type="button" class="el8button close-pt-comments-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-doc-id="' + soy.$$escapeHtml(opt_data.id) + '">End Conversation</button></li>' : '') : '') + ((el8Globals.PASSPORT_EMR) ? (el8Globals.APP == 'home') ? '<li class="el8ButtonItem"><button type="button" class="launch-patient-trigger el8PrimaryButton ebs-btn ebs-btn-primary el8LargeButton" data-id="' + soy.$$escapeHtml(opt_data.patientId) + '">View All</button></li>' : (opt_data.modelClass == 'LetterReceipt' && el8Globals.APP == 'chart') ? '<li class="el8ButtonItem"><button type="button" class="print-receipt-trigger el8SecondaryButton ebs-btn ebs-btn-default el8LargeButton" data-id="' + soy.$$escapeHtml(opt_data.patientId) + '">Print</button></li><li class="el8ButtonItem"><button type="button" class="download-receipt-trigger el8SecondaryButton ebs-btn ebs-btn-default el8LargeButton" data-id="' + soy.$$escapeHtml(opt_data.patientId) + '">Save to Computer</button></li>' : '' : '') + ((! opt_data.signDate && el8Globals.PASSPORT_EMR && ! el8Globals.READ_ONLY) ? (opt_data.modelClass == 'LetterReceipt' && el8Globals.APP == 'chart') ? '<li class="el8ButtonItem"><button type="button" class="sign-letter-receipt el8SecondaryButton ebs-btn ebs-btn-default el8LargeButton" data-id="' + soy.$$escapeHtml(opt_data.patientId) + '">' + ((el8Globals.USER_STAFF_TYPE == 'OfficeStaff') ? 'File into Chart' : 'Sign off') + '</button></li>' : '' : '') + ((opt_data.modelClass == 'Letter' && ! opt_data.sendToAccessUserId && ! el8Globals.READ_ONLY) ? '<li class="el8ButtonItem"><button type="button" class="el8button close-letter-comments-trigger el8SecondaryButton ebs-btn ebs-btn-default">End Conversation</button></li>' : '') + '</ul></li>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm._passportReplyTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.closeTime) {
    output.append((opt_data.comments.length) ? '<div class="el8ResponseDisclaimer color999">If you have any further questions about this matter, please call Dr. ' + soy.$$escapeHtml(opt_data.primaryPhysicianLastName) + '\'s office' + ((opt_data.primaryPhysicianPhone) ? ' at ' + soy.$$escapeHtml(opt_data.primaryPhysicianPhone) : '') + '.</div>' : '');
  } else if (! el8Globals.READ_ONLY) {
    output.append('<div class="comment-reply-container el8ResponsesReplyWrap"><div class="comment-reply-trigger el8FieldTrigger el8StandardFontSize" data-doc-id="', soy.$$escapeHtml(opt_data.id), '" tabindex="0">');
    el8.template.shared.commentReplyForm.replyText(null, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm._accessReplyTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (! el8Globals.READ_ONLY) {
    output.append('<div class="comment-reply-container el8ResponsesReplyWrap"><div class="comment-reply-trigger el8FieldTrigger el8StandardFontSize" data-doc-id="', soy.$$escapeHtml(opt_data.id), '">');
    el8.template.shared.commentReplyForm.replyText(null, output);
    output.append('</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm.replyText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (el8Globals.PASSPORT_EMR) {
    output.append('Reply to practice...');
  } else {
    switch (el8Globals.APP) {
      case 'passport':
        output.append('Reply to doctor\'s office...');
        break;
      case 'access':
        output.append('Reply to practice...');
        break;
      case 'chart':
      case 'home':
        output.append('Reply to recipient...');
        break;
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.shared.commentReplyForm.commentsClosedError = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (el8Globals.APP) {
    case 'passport':
      output.append('Sorry, this conversation was closed by your physician, so your response could not be saved.');
      break;
    case 'chart':
    case 'home':
      output.append('Sorry, this conversation was closed by another user, so your response could not be saved.');
      break;
  }
  if (!opt_sb) return output.toString();
};
